import React from "react";
import { Card, Typography, Row, Col, Button, Space } from "antd";
import { UserOutlined, ShoppingOutlined, HeartOutlined, SettingOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "./SecureClient.scss";

const { Title, Text } = Typography;

const SecureClient = () => {
  const navigate = useNavigate();

  const menuItems = [
    {
      key: "profile",
      title: "הפרופיל שלי",
      description: "עדכן את פרטי החשבון שלך",
      icon: <UserOutlined style={{ fontSize: 48 }} />,
      path: "/p/dashboard/profile",
      color: "#1890ff",
    },
    {
      key: "orders",
      title: "ההזמנות שלי",
      description: "צפה בהזמנות שלך",
      icon: <ShoppingOutlined style={{ fontSize: 48 }} />,
      path: "/p/dashboard/orders",
      color: "#52c41a",
    },
    {
      key: "saved",
      title: "חבילות שמורות",
      description: "חבילות ששמרת למועד מאוחר יותר",
      icon: <HeartOutlined style={{ fontSize: 48 }} />,
      path: "/p/dashboard/saved",
      color: "#eb2f96",
    },
    {
      key: "settings",
      title: "הגדרות",
      description: "הגדרות חשבון והעדפות",
      icon: <SettingOutlined style={{ fontSize: 48 }} />,
      path: "/p/dashboard/settings",
      color: "#722ed1",
    },
  ];

  return (
    <div className="secure-client-page">
      <Row gutter={[24, 24]}>
        <Col xs={24}>
          <Card>
            <Title level={1}>אזור אישי</Title>
            <Text type="secondary">
              ברוך הבא לאזור האישי שלך. כאן תוכל לנהל את החשבון וההזמנות שלך.
            </Text>
          </Card>
        </Col>

        {menuItems.map((item) => (
          <Col xs={24} sm={12} lg={6} key={item.key}>
            <Card
              hoverable
              className="menu-card"
              onClick={() => navigate(item.path)}
              style={{
                textAlign: "center",
                height: "100%",
                border: `2px solid ${item.color}`,
              }}
            >
              <Space direction="vertical" size="large" style={{ width: "100%" }}>
                <div style={{ color: item.color }}>{item.icon}</div>
                <Title level={4} style={{ margin: 0 }}>
                  {item.title}
                </Title>
                <Text type="secondary">{item.description}</Text>
                <Button type="primary" style={{ backgroundColor: item.color, borderColor: item.color }}>
                  כניסה
                </Button>
              </Space>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default SecureClient;
